/* eslint-disable camelcase */

import Vault from './helpers/Vault';
import ApiDirector from './components/ApiDirector';

class Notifications {
  constructor({ openDialog }) {
    this.accepted = false;
    this.notices = {};
    this.openDialog = openDialog;
    // Let it be known Notifications would like the token if available.
    Vault.get(Vault.keys.PUSH_TOKEN)
      .then(this.setToken)
      // if token isn't found, it's alright.
      .catch(() => {});
    this.prefs = {
      favorite_markets: true,
    };
  }

  setToken = (token) => {
    // The token isn't "needed", but it indicates that we have permission to notify
    // When we have this we can skip prompting.
    if (token) {
      this.token = token;
      this.accepted = true;
    }
  }

  getToken = () => this.token;

  setNotices = (notices) => {
    this.notices = notices;
  }

  setPrefs = (prefs) => {
    Console.log('setting prefs', prefs);
    this.prefs = prefs;
  }

  requestPermissions = (dialogDetails, cb) => {
    // FIXME: detect iOS properly
    if (false) {
      this.openDialog({
        ...dialogDetails,
        onAccept: () => {
          Vault.get(Vault.keys.PUSH_TOKEN)
            .then((token) => {
              this.setToken(token);
              cb();
            });
        },
      });
    }
  }

  scheduleMarketFavoriteNotifications = (market) => {
    // early return, do not schedule notifications if the user doesn't
    // have it in their preferences.
    if (!this.prefs.favorite_markets) {
      return;
    }
    if (!this.accepted) {
      this.requestPermissions(this.dialogForMarkets(), () => {
        // eslint-disable-next-line
        this._scheduleMarketFavoriteNotifications(market);
      });
    } else {
      // eslint-disable-next-line
      this._scheduleMarketFavoriteNotifications(market);
    }
  }

  scheduleMultipleMarketFavoriteNotifications = (markets = []) => {
    // early return, do not schedule notifications if the user doesn't
    // have it in their preferences.
    if (!this.prefs.favorite_markets) {
      return;
    }
    const run = () => {
      // eslint-disable-next-line
      markets.forEach(this._scheduleMarketFavoriteNotifications);
    };
    if (!this.accepted) {
      // For now, we will not request permissions when scheduling via multiple.
      // We'll only request notification permissions on an explicit market favorite.
      // this.requestPermissions(this.dialogForMarkets(), run);
    } else {
      run();
    }
  }

  _scheduleMarketFavoriteNotifications = (market) => {
    // eslint-disable-next-line
    const { name, market_events = [] } = market;
    // Need to schedule two notifications per market event.
    /*
    market_events.forEach(({
      order_window_start,
      order_window_notification_start,
      order_window_close,
      order_window_notification_close,
      id,
    }) => {
      // 1, for when the market is starting to take orders.
      const startMessage = template(this.notices['Notification Order Window Start'] || '<%= market_name %> is open for ordering.')({
        market_name: name,
      });
      // 2, for when the market window is closing in 16 hours.
      const closingMessage = template(this.notices['Notification Order Window Close'] || '<%= market_name %> is closing for ordering soon.')({
        market_name: name,
      });
    });
    */
  }

  promptForOrderNotifications = () => {
    if (!this.accepted) {
      this.requestPermissions(this.dialogForOrders());
    }
  }

  baseDialog = () => ({
    positiveText: this.notices['Notification Dialog Positive Text'] || 'Yes',
    negativeText: this.notices['Notification Dialog Negative Text'] || 'No, thanks',
    title: this.notices['Notification Dialog Title'] || 'Market2Day Notifications',
  })

  dialogForOrders = () => ({
    ...this.baseDialog(),
    description: this.notices['Notification Dialog Order Description'] || `
      Would you like to receive a push notification when your order is out for delivery?
    `.trim(),
  })

  dialogForMarkets = () => ({
    ...this.baseDialog(),
    description: this.notices['Notification Dialog Markets Description'] || `
      Would you like to receive a push notification when your favorite markets are open for ordering?
    `.trim(),
  })

  // Change preferences for user
  // eslint-disable-next-line
  changePreferences = (user, notification_prefs) => (
    ApiDirector.fetch(`user_profiles/${user.email}`, {
      method: 'PATCH',
      body: JSON.stringify({
        user_profile: {
          notification_prefs,
        },
      }),
    })
  )
}

export default Notifications;
